"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelSettings = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const UserPanelLayout_1 = require("./views/UserPanelLayout");
const UserPanelSettingsModalView_1 = require("./views/UserPanelSettingsModalView");
const UserPanelSettingsView_1 = require("./views/UserPanelSettingsView");
function UserPanelSettings({ logo, }) {
    const [modalOpen, setModalOpen] = (0, react_1.useState)(false);
    const { data: user } = (0, app_1.useQuery)('me', {
        select: {
            email: true,
            phone: true,
            name: true,
            newsletter: true,
        },
    });
    return ((0, jsx_runtime_1.jsx)(UserPanelLayout_1.UserPanelLayout, Object.assign({ logo: logo }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(UserPanelSettingsView_1.UserPanelSettingsView, { user: user, openModal: () => setModalOpen(true) }), user && ((0, jsx_runtime_1.jsx)(UserPanelSettingsModalView_1.UserPanelSettingsModalView, { user: user, open: modalOpen, closeModal: () => setModalOpen(false) }))] }) })));
}
exports.UserPanelSettings = UserPanelSettings;
